// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c216c89a","239":"a56e7e7d","553":"d354de48","727":"b665fd45"}[chunkId] + ".chunk.js";
};